import React from "react";
import IFieldOptions from "../../../../../../model/interface/form/elementOptions/IFieldOptions";
import FormFieldType from "./FormFieldType";
import LocaleProvider from "../../../../../../i18n/LocaleProvider";
import DatePicker from "components/shared/input/DatePicker";
import TimePicker from "components/shared/input/TimePicker";
import moment, {Moment} from "moment";
import {range} from "underscore";

class FormFieldDate {
    public static render = (options: IFieldOptions) => {
        const props = {
            style: options.style,
            placeholder: options.placeholder,
            allowClear: options.showClear,
            disabled: options.disabled,
            value: options.value,
            format: '' || options.datePickerFormat,
            confirm: options.datePickerConfirm
        };

        const isDisabledDate = (date: Moment) =>
            (!!options.datePickerAllowedFrom && date.isBefore(moment().subtract(options.datePickerAllowedFrom, 's'), 'day')) || (!!options.datePickerAllowedTo && date.isAfter(moment().add(options.datePickerAllowedTo, 's'), 'day'))

        const isDisabledTime = (date: Moment | null) => {
            return {
                disabledHours: () => range(0, 24).filter(hours => !date || (isDisabledDate(date) || ((!!options.datePickerAllowedFrom && date.clone().hour(hours).unix() < moment().subtract(options.datePickerAllowedFrom, 's').unix()) || ((!!options.datePickerAllowedTo && date.clone().hour(hours).unix() > moment().add(options.datePickerAllowedTo, 's').unix()))))),
                disabledMinutes: () => range(0, 60).filter(minutes =>!date || (isDisabledDate(date) || ((!!options.datePickerAllowedFrom && date.clone().minute(minutes).unix() < moment().subtract(options.datePickerAllowedFrom, 's').unix()) || ((!!options.datePickerAllowedTo && date.clone().minute(minutes).unix() > moment().add(options.datePickerAllowedTo, 's').unix()))))),
                disabledSeconds: () => range(0, 60).filter(seconds => !date || (isDisabledDate(date) || ((!!options.datePickerAllowedFrom && date.clone().second(seconds).unix() < moment().subtract(options.datePickerAllowedFrom, 's').unix()) || ((!!options.datePickerAllowedTo && date.clone().second(seconds).unix() > moment().add(options.datePickerAllowedTo, 's').unix()))))),
            }
        }
        switch (options.datePicker) {
            case FormFieldType.FIELD_DATE_DATE_PICKER:
                return <DatePicker disabledDate={isDisabledDate} locale={LocaleProvider.getPicker()} {...props} />
            case FormFieldType.FIELD_DATE_DATE_TIME_PICKER:
                return <DatePicker disabledDate={isDisabledDate} disabledTime={isDisabledTime}
                                   showTime={{format: options.datePickerTimeFormat}}
                                   locale={LocaleProvider.getPicker()} {...props} />
            case FormFieldType.FIELD_DATE_TIME_PICKER:
                return <TimePicker locale={LocaleProvider.getPicker()} {...props}
                                   format={options.datePickerTimeFormat}/>
            default:
                return <DatePicker disabledDate={isDisabledDate} mode={options.datePicker}
                                   locale={LocaleProvider.getPicker()} {...props} />
        }
    }
}

export default FormFieldDate